module.exports = __webpack_public_path__ + "images/help_v2/masthead@2x-95c81c59bdb2bbcbdfae22c54e44e4ac.png";